import { createEnvelopeSource } from './create-envelope-source';
import { DOC31_EDITION_ID } from './doc31-edition';

/**
 * Badge earn rates and bonus-action completion rates of one 31DOC edition
 * (`GET /analytics/engagement-drivers-31doc`), one bar per badge and per
 * action of the edition's own catalog. National only.
 */
export const engagementDrivers31docSource = createEnvelopeSource({
    label: '31DOC engagement drivers',
    endpoint: 'analytics/engagement-drivers-31doc',
    metrics: [
        { id: 'badgeEarnRate', label: 'Badge earn rate', type: 'ratio' },
        {
            id: 'bonusCompletionRate',
            label: 'Bonus completion rate',
            type: 'ratio',
        },
    ],
    forms: ['bars'],
    regionGrain: 'national',
    staticParams: { campaignId: DOC31_EDITION_ID },
});
